<form [formGroup]="form" autocomplete="off" class="form-horizontal">

  <div class="form-row">
    <label class="col-sm-4 col-form-label"
           for="artTaetigkeit"
           title="{{ 'COMMON_UI.FRAGEBOGEN.TAETIGKEIT_ANGABEN.TAETIGKEITART' | translate }}">{{ 'COMMON_UI.FRAGEBOGEN.TAETIGKEIT_ANGABEN.TAETIGKEITART' | translate }}</label>
    <div class="col-sm-8">
      <textarea class="form-control" datevMessagePath="artTaetigkeit{{objectId}}" formControlName="artTaetigkeit" id="artTaetigkeit" rows="6"
                type="text"
                utilsCheckValidity
                utilsControlState
                utilsMarkRequired
                utilsValidationMessage>
      </textarea>
    </div>
  </div>

  <div *ngIf="useBezeichnung" class="form-row">
    <label class="col-sm-4 col-form-label"
           for="bezeichnung"
           title="{{ 'COMMON_UI.FRAGEBOGEN.TAETIGKEIT_ANGABEN.BEZEICHNUNG' | translate }}">{{ 'COMMON_UI.FRAGEBOGEN.TAETIGKEIT_ANGABEN.BEZEICHNUNG' | translate }}</label>
    <div class="col-sm-8">
      <input class="form-control" datevMessagePath="bezeichnung{{objectId}}" formControlName="bezeichnung" id="bezeichnung"
             type="text"
             utilsCheckValidity
             utilsControlState
             utilsValidationMessage
      />
    </div>
  </div>

  <div *ngIf="useBeginnTaetigkeit" class="form-row">
    <label class="d-none d-sm-inline col-sm-3 col-form-label" for="beginnTaetigkeit">
      <span class="d-flex justify-content-between">
        <span>{{ 'COMMON_UI.FRAGEBOGEN.TAETIGKEIT_ANGABEN.TAETIGKEITBEGINN' | translate }}</span>
      </span>
    </label>
    <div class="d-none d-sm-flex col-sm-1 small-stammdaten-button">
      <common-ui-daten-uebernahme (picked)="form.get('beginnTaetigkeit').setValue($event)"
                                  [itemTemplate]="stammdatenTemplate"
                                  [items]="beginnDerTaetigkeitStammdaten"
                                  [readonly]="readonly"
                                  context="beginnTaetigkeit"
                                  imageOnly="true"></common-ui-daten-uebernahme>
    </div>
    <div class="col-sm-8">
      <date-picker
              id="beginnTaetigkeit"
              messagePath="beginnTaetigkeit"
              formControlName="beginnTaetigkeit"
              [isRequired]=true>
      </date-picker>
    </div>
  </div>
  <ng-template #stammdatenTemplate let-item="item">
    <h4
      class="list-group-item-heading">{{ 'COMMON_UI.FRAGEBOGEN.BEGINN_TAETIGKEIT_WJ_STAMMKAPITAL_ANGABEN.BEGINN' | translate }}</h4>
    <p class="list-group-item-text"> {{item}}</p>
  </ng-template>
</form>
